<template>
  <v-combobox
    v-model="select"
    :items="resItems"
    :label="label"
    :item-text="itemText"
    :item-value="itemValue"
    :prepend-icon="prependIcon"
    :hint="hint"
    multiple
    :disabled="curentDisabled"
    @click:append="() => this.select = []"
    :append-icon="'mdi-close'"
    :allow-overflow="false"
    return-object
    :readonly="readonly"
    single-line
    :no-data-text="noDataText"
  >
    <template v-slot:selection="{ item, index }">
      <div  style="overflow: hidden">

        <v-chip v-if="index < displayCount">
          <span>{{item[`${itemText}`]}}</span>
        </v-chip>
        <span
          v-else-if="(index === displayCount)"
          class="grey--text caption"
        >
          (+{{ select.length - index }} others)
        </span>

      </div>

    </template>
  </v-combobox>
</template>

<script>
export default {
  props: {
    label: String,
    getRequest: {
      type: Object,
      default: null,
    },
    paramsRequest: {
      type: Object,
      default: null,
    },
    prependIcon: String,
    itemText: String,
    itemValue: String,
    noDataText: String,
    itemsRoot: Array,
    filtered: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Number,
      default: 0,
    },
    displayCount: {
      type: Number,
      default: 1
    },
    selectedItems: Array
  },
  data (){
    return {
      items: [],
      select: [],
      readonly: false,
      hint: '',
      curentDisabled: false,
      flagOut: true,
      flagIn: true,
    };
  },
  methods:{
    update(){
      this.getRequest.get(this.paramsRequest)
        .then(response => response.data)
        .then(json => {
          this.items = json;
          this.$emit('items', this.items);
        }
        )
        .catch(error => {
          console.error(error);
        });
    },
    checkedItemRoot(){
      if (!this.itemsRoot || this.itemsRoot.length < 1){
        this.readonly = true;
        this.hint = this.noDataText;
      }
      else {
        this.readonly = false;
        this.hint = '';
      }
    },
    checkDisabled(items){
      if(this.disabled !== null && this.disabled !== undefined && this.disabled === 1 || this.disabled === 2 && (items === null || items === undefined || items.length === 1))
        this.curentDisabled = true;
      else
        this.curentDisabled = false;
    },
  },
  watch:{
    selectedItems(){
      if (this.flagOut){
        this.flagIn = false;
        this.select = this.selectedItems;
      }
      else
        this.flagOut = true;
    },
    select(){
      if(this.flagIn){
        this.flagOut = false;
        this.$emit('changed', this.select);
      }
      else {
        this.flagIn = true;
      }
    },
    itemsRoot(){
      if (this.itemsRoot !== null && this.itemsRoot.length === 1){
        this.select.push(this.itemsRoot[0]);
      }
    },

    items(){
      if (this.items !== null && this.items.length === 1){
        this.select.push(this.items[0]);
      }
    },
  },
  computed:{
      
    resItems(){
      if(this.filtered){
        this.checkedItemRoot();
        this.checkDisabled(this.itemsRoot);

        return this.itemsRoot;
      }

      this.checkDisabled(this.items);

      return this.items;
    },
  },
  async mounted() {
    if (!this.filtered)
      this.update();
  },
};
</script>